import { ADD_BOOK_INFO, REMOVE_BOOK_INFO } from "./actionTypes";

const initialState = {
    bookInfos: []
}

const bookingReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_BOOK_INFO:
            const newBookInfo = {
                id: state.bookInfos.length > 0 ? Math.max(...state.bookInfos.map(book => book.id)) + 1 : 1,
                ...action.payload
            };
            return {
                ...state,
                bookInfos: [...state.bookInfos, newBookInfo]
            };
        case REMOVE_BOOK_INFO:
            return {
                ...state,
                //...state.bookInfos.splice(action.payload, 1),
                bookInfos: state.bookInfos.filter((bookInfo) => bookInfo.id !== action.payload),
            };
        default:
            return state;
    }
}
export default bookingReducer;